import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { FlexBetween, FlexCenter } from '../../global/commonStyle';

interface Props {
  isLast?: boolean;
}
const Box = styled.div<Props>`
  padding: var(--space-12) var(--space-16);
  ${FlexBetween}
  gap: var(--space-12);
  border-bottom: ${({ isLast }) => (isLast ? 'none' : `0.5px solid var(--border-primary)`)};
`;

const LeftContent = styled.div`
  display: flex;
  gap: var(--space-16);
  align-items: flex-start;
`;

const Logo = styled.div`
  ${FlexCenter}
  padding-top: var(--space-4);
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  max-width: 479px;
  width: 100%;
`;

const Title = styled.div`
  color: var(--text-primary);
  ${Typography.body_lg_medium}
  ${mobile_xl(css`
    margin-block: var(--space-2);
  `)}
`;

const Desc = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md}
  max-width: 479px;
  width: 100%;
`;

const RightContent = styled.div``;

const Tag = styled.div`
  border-radius: var(--border-radius-6);
  border: 1px solid var(--brand-secondary);
  background: var(--brand-secondary);
  color: var(--brand-primary);
  ${Typography.body_sm};
  padding: var(--space-2) var(--space-5);
`;
const TagBtn = styled.div`
  border-radius: var(--border-radius-6);
  border: 1px solid var(--neutral-secondary);
  background: var(--neutral-secondary);
  color: var(--text-secondary);
  ${Typography.body_sm};
  padding: var(--space-2) var(--space-5);
  ${mobile_xl(css`
    width: max-content;
  `)}
`;

const Btn = styled.div`
  color: var(--brand-primary);
  ${Typography.body_md_medium}
  cursor: pointer;
  text-decoration: none;
  ${mobile_xl(css`
    width: max-content;
    padding-block: var(--space-4);
  `)}
`;

const View = styled.p`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  cursor: pointer;
  span {
    color: var(--accent-error);
  }
  &:hover {
    color: var(--border-secondary);
  }
`;

const ConnectedDiv = styled.div`
  .disconnect-button {
    display: none;
  }
  &:hover {
    .disconnect-button {
      display: flex;
    }
    .connect-button {
      display: none;
    }
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const TitleContainer = styled.div`
  ${mobile_xl(css`
    ${FlexBetween}
  `)}
`;
export {
  LeftContent,
  RightContent,
  Box,
  Logo,
  Description,
  Title,
  Desc,
  Tag,
  TagBtn,
  Btn,
  View,
  ConnectedDiv,
  DetailsContainer,
  TitleContainer
};
